export class DocumentDetail {
  constructor(public metaDataId?: number,
    public farm?: string[],
    public site?: string[],
    public title?: string,
    public date?: string,
    public month?: number,
    public year?: number,
    public author?: string,
    public accessionNo?: string,
    public downloadId?: number,
    public filename?: string) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/models/document-detail.ts